
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useRef } from "react";
import { FiMoreVertical } from "react-icons/fi";
import { Clock3, CheckCircle, Clock, XCircle, Search } from "lucide-react";
import "./fulltranscations.css";

const Transactionsfull = () => {
  const [activeTab, setActiveTab] = useState("Recent");
  const [search, setSearch] = useState("");
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);

  const [activeDropdown, setActiveDropdown] = useState(null);
  const [statusSelectDropdown, setStatusSelectDropdown] = useState(null);
  const [modalData, setModalData] = useState(null);
  const [modalInput, setModalInput] = useState("");
  const [confirmModal, setConfirmModal] = useState(false);
const actionRef = useRef(null);
const firstDropdownRef = useRef(null);
const secondDropdownRef = useRef(null);
const modalRef = useRef(null);
  const statusColors = {
    Pending: "#FFA500",
    Paid: "#4CAF50",
    Failed: "#F44336",
  };

  const fetchPayLinks = async () => {
    setLoading(true);
    try {
      const res = await axios.get("https://bodhimaram.onrender.com/paylinks");
      const sorted = res.data.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at),
      );
      setTransactions(sorted);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPayLinks();
  }, []);

  const openStatusModal = (transaction, status) => {
    setModalData({ ...transaction, status });
    setModalInput("");
    setConfirmModal(false);
  };

  const handleConfirmStatusChange = async () => {
    if (!modalData) return;
    try {
      const res = await fetch(
        `https://bodhimaram.onrender.com/paylinks/${modalData.id}/status`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            status: modalData.status,
            details: modalInput,
          }),
        },
      );
      if (!res.ok) throw new Error("Failed to update status");
      fetchPayLinks();
      setModalData(null);
      setConfirmModal(false);
      setActiveDropdown(null);
      setStatusSelectDropdown(null);
    } catch (err) {
      console.error(err);
      alert("⚠️ Failed to update status");
    }
  };

  const handleSendReminder = (transaction, type) => {
    const message = `Hi ${transaction.student_name}, 👋\n\nYour fee amount of ₹${transaction.amount} for ${transaction.student_name} is due.\nPlease complete your payment securely.\n\n— Saaragka InfoTech 💻`;
    if (type === "whatsapp") {
      window.open(
        `https://wa.me/${transaction.phone}?text=${encodeURIComponent(
          message,
        )}`,
        "_blank",
      );
    } else {
      window.open(
        `sms:${transaction.phone}?body=${encodeURIComponent(message)}`,
        "_blank",
      );
    }
  };
useEffect(() => {
  const handleClickOutside = (e) => {
    if (
      firstDropdownRef.current &&
      !firstDropdownRef.current.contains(e.target) &&
      secondDropdownRef.current &&
      !secondDropdownRef.current.contains(e.target) &&
      actionRef.current &&
      !actionRef.current.contains(e.target)
    ) {
      setActiveDropdown(null);
      setStatusSelectDropdown(null);
    }

    if (
      modalData &&
      modalRef.current &&
      !modalRef.current.contains(e.target)
    ) {
      setModalData(null);
      setConfirmModal(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);

  return () =>
    document.removeEventListener("mousedown", handleClickOutside);
}, [modalData]);
  // Filter & search
  const filteredTransactionss = transactions
    .filter((t) => {
      if (activeTab === "Paid") return t.status.toLowerCase() === "paid";
      if (activeTab === "Pending") return t.status.toLowerCase() === "pending";
      if (activeTab === "Failed") return t.status.toLowerCase() === "failed";
      return true;
    })
    .filter((t) => t.student_name.toLowerCase().includes(search.toLowerCase()));





  return (
    <div className="transactions-container">
      <h1>Transactions</h1>

      <div className="tabss">
        {[
          { name: "Recent", icon: <Clock3 size={16} /> },
          { name: "Paid", icon: <CheckCircle size={16} /> },
          { name: "Pending", icon: <Clock size={16} /> },
          
          { name: "Failed", icon: <XCircle size={16} /> },
        ].map((tab) => (
          <button
            key={tab.name}
            className={`tabs-btn ${activeTab === tab.name ? "active" : ""}`}
            onClick={() => setActiveTab(tab.name)}
          >
            {tab.icon}
            <span>{tab.name}</span>
          </button>
        ))}
      </div>

      <div className="filter-row">
        <div className="search-box">
          <Search size={18} className="search-icon" />

          <input
            type="text"
            placeholder="Search Customer Name"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>
      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Mobile Number</th>
              <th>Requested On</th>
              <th>Paid On</th>
              <th>Settled On</th>
              <th>Amount</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="8" className="no-data">
                  Loading...
                </td>
              </tr>
            ) : filteredTransactionss.length > 0 ? (
              filteredTransactionss.map((t, i) => {
                const status = t.status.toLowerCase();
                return (
                  <tr key={i}>
                    <td>
                      <div className="name-cell">
                        <strong className="name">{t.student_name}</strong>
                        <span className="subtext">{t.class_name}</span>
                      </div>
                    </td>
                    <td>{t.phone}</td>
                    <td>{new Date(t.created_at).toLocaleDateString()}</td>
                    <td>
                      {status === "paid"
                        ? new Date(t.status_updated_at).toLocaleDateString()
                        : "--"}
                    </td>
                    <td>--</td>
                    <td>
                      <span className={`amount-tag ${status}`}>
                        ₹{t.amount}
                      </span>
                    </td>
                    <td className={`tr-status ${status}`}>
                      {status === "paid" ? (
                        <>
                          <CheckCircle size={14} style={{ marginRight: 4 }} />{" "}
                          Paid
                        </>
                      ) : (
                        <>
                          <XCircle size={14} style={{ marginRight: 4 }} />{" "}
                          {t.status.charAt(0).toUpperCase() + t.status.slice(1)}
                        </>
                      )}
                    </td>

                  
                    <td>
                      <div className="action-wrapper">
                        <button
                        ref={actionRef}
                          className="qp_action_btn"
                          onClick={() => {
                            setActiveDropdown(
                              activeDropdown === t.id ? null : t.id,
                            );
                            setStatusSelectDropdown(null);
                          }}
                        >
                          <FiMoreVertical />
                        </button>

                        {activeDropdown === t.id && (
                          <div  ref={firstDropdownRef} className="qp_first_dropdown">
                            <button
                              onClick={() => setStatusSelectDropdown(t.id)}
                            >
                              Change Status
                            </button>
                            <button
                              onClick={() => handleSendReminder(t, "whatsapp")}
                            >
                              Send WhatsApp
                            </button>
                            <button
                              onClick={() => handleSendReminder(t, "sms")}
                            >
                              Send SMS
                            </button>
                          </div>
                        )}

                        {statusSelectDropdown === t.id && (
                          <div   ref={secondDropdownRef} className="qp_status_select_dropdown">
                            <button onClick={() => openStatusModal(t, "Paid")}>
                              Paid
                            </button>
                            <button
                              onClick={() => openStatusModal(t, "Pending")}
                            >
                              Pending
                            </button>
                            <button
                              onClick={() => openStatusModal(t, "Failed")}
                            >
                              Failed
                            </button>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="8" className="no-data">
                  No {activeTab} transactions
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="transaction-list">
        {filteredTransactionss.map((t) => (
          <div className="transaction-card" key={t.id}>
            <div className="user-section">
              <img
                src="https://ui-avatars.com/api/?name=Student"
                alt=""
                className="avatar"
              />

              <div>
                <h3>{t.student_name}</h3>
                <p>{t.class_name}</p>
                <p>{t.phone}</p>
              </div>
            </div>

            <div className="date-section">
              <p>{new Date(t.created_at).toLocaleDateString()}</p>
            </div>

            <div className="amount-section">
              <h2>₹{t.amount}</h2>
              <span className={`tr-status ${t.status.toLowerCase()}`}>
                {t.status}
              </span>
            </div>

          
            <div className="mobile-action">
              <button
              ref={actionRef}
                className="qp_action_btn"
                onClick={() =>
                  setActiveDropdown(activeDropdown === t.id ? null : t.id)
                }
              >
                <FiMoreVertical />
              </button>

              {activeDropdown === t.id && (
                <div ref={firstDropdownRef} className="qp_first_dropdown">
                  <button onClick={() => setStatusSelectDropdown(t.id)}>
                    Change Status
                  </button>
                  <button onClick={() => handleSendReminder(t, "whatsapp")}>
                    Send WhatsApp
                  </button>
                  <button onClick={() => handleSendReminder(t, "sms")}>
                    Send SMS
                  </button>
                </div>
              )}

              {statusSelectDropdown === t.id && (
                <div   ref={secondDropdownRef} className="qp_status_select_dropdown">
                  <button onClick={() => openStatusModal(t, "Paid")}>
                    Paid
                  </button>
                  <button onClick={() => openStatusModal(t, "Pending")}>
                    Pending
                  </button>
                  <button onClick={() => openStatusModal(t, "Failed")}>
                    Failed
                  </button>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Modal */}
      {modalData && (
        <div className="qp_modal_overlay">
          <div
           ref={modalRef}
            className="qp_modal_box"
            style={{ borderTop: `6px solid ${statusColors[modalData.status]}` }}
          >
            <h3>Update Status: {modalData.status}</h3>
            <p>
              <b>Student:</b> {modalData.student_name}
            </p>
            <p>
              <b>Phone:</b> {modalData.phone}
            </p>
            <p>
              <b>Amount:</b> ₹{modalData.amount}
            </p>

            <input
              type="text"
              placeholder={
                modalData.status === "Paid"
                  ? "Enter UTR / Payment Details"
                  : "Enter reason"
              }
              value={modalInput}
              onChange={(e) => setModalInput(e.target.value)}
            />

            {!confirmModal ? (
              <div className="qp_modal_buttons">
                <button
                  onClick={() => setConfirmModal(true)}
                  className="qp_confirm_btn"
                >
                  Save
                </button>
                <button
                  onClick={() => setModalData(null)}
                  className="qp_cancel_btn"
                >
                  Cancel
                </button>
              </div>
            ) : (
              <div className="qp_modal_buttons">
                <button
                  onClick={handleConfirmStatusChange}
                  className="qp_confirm_btn"
                >
                  Confirm
                </button>
                <button
                  onClick={() => setConfirmModal(false)}
                  className="qp_cancel_btn"
                >
                  Back
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Transactionsfull;
